module.exports = __webpack_public_path__ + "static/media/Mikrosatelitni_lokus.22f52d65.md";